import { render, staticRenderFns } from "./ChannelList.vue?vue&type=template&id=ca5980b0&"
import script from "./ChannelList.vue?vue&type=script&lang=js&"
export * from "./ChannelList.vue?vue&type=script&lang=js&"
import style0 from "./ChannelList.vue?vue&type=style&index=0&id=ca5980b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../kiwiirc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports